import Swiper from 'swiper';

class BandeauSlider {

	constructor(){
		this.component = document.querySelector('[data-component="bandeau-slider"]');
		this._init();
	}

	_init(){

		if( this.component ){
			
			let swiper = new Swiper('[data-component="bandeau-slider"]', {
				// pagination         : '[data-target="bandeau-slider-pagination"]',
				// paginationClickable: true,
				direction: 'vertical',
				autoplay : 5000
			});
			
	  }
	}

}

export const bandeauSlider = new BandeauSlider();